import GUI from 'lil-gui';
import type { Tuning } from '../game/tuning';

export class DebugTools {
  private gui: GUI | null = null;

  /** `onFlowChange` re-bakes the water; `onRenderChange` applies exposure/DPR. */
  constructor(tuning: Tuning, onFlowChange: () => void, onRenderChange: () => void) {
    const enabled = new URLSearchParams(window.location.search).has('debug');
    if (!enabled) return;

    this.gui = new GUI({ title: 'Ducky tuning' });
    const water = this.gui.addFolder('Water');
    water.add(tuning, 'baseFlow', 0.5, 8, 0.1).onFinishChange(onFlowChange);
    water.add(tuning, 'laneBoost', 0, 10, 0.1).onFinishChange(onFlowChange);
    water.add(tuning, 'laneWidth', 0.5, 4, 0.05).onFinishChange(onFlowChange);
    water.add(tuning, 'whirlSwirl', 0, 12, 0.1).onFinishChange(onFlowChange);
    water.add(tuning, 'whirlPull', 0, 8, 0.1).onFinishChange(onFlowChange);
    const duck = this.gui.addFolder('Duck');
    duck.add(tuning, 'grip', 0.3, 6, 0.05);
    duck.add(tuning, 'nudgeAccel', 1, 20, 0.1);
    duck.add(tuning, 'hitKeep', 0, 1, 0.05);
    duck.add(tuning, 'spinKeep', 0, 1, 0.05);
    duck.add(tuning, 'spinTime', 0, 1.5, 0.05);
    duck.add(tuning, 'recoverAccel', 0, 20, 0.5);
    duck.add(tuning, 'recoverTime', 0, 3, 0.1);
    water.add(tuning, 'rockWake', 0, 1, 0.05).onFinishChange(onFlowChange);
    const paddle = this.gui.addFolder('Paddle');
    paddle.add(tuning, 'paddleKick', 0, 6, 0.1);
    paddle.add(tuning, 'paddleFastBonus', 0, 8, 0.1);
    paddle.add(tuning, 'glideTime', 0, 2, 0.05);
    paddle.add(tuning, 'paddleRecharge', 1, 30, 0.5);
    paddle.add(tuning, 'crumbCharge', 0, 0.5, 0.01);
    paddle.add(tuning, 'crumbKick', 0, 2, 0.05);
    paddle.add(tuning, 'flapKick', 0, 4, 0.1);
    paddle.add(tuning, 'flapCap', 1, 6, 0.1);
    const view = this.gui.addFolder('View');
    view.add(tuning, 'cameraLag', 0.02, 0.8, 0.01);
    view.add(tuning, 'maxDpr', 1, 2, 0.25).onChange(onRenderChange);
    view.add(tuning, 'exposure', 0.6, 1.8, 0.01).onChange(onRenderChange);
  }

  setHidden(hidden: boolean): void {
    if (!this.gui) return;
    if (hidden) this.gui.hide();
    else this.gui.show();
  }

  dispose(): void {
    this.gui?.destroy();
    this.gui = null;
  }
}
